import { render, staticRenderFns } from "./weekdaysTextTransformer.vue?vue&type=template&id=7fc22cb7&scoped=true"
import script from "./weekdaysTextTransformer.vue?vue&type=script&lang=js"
export * from "./weekdaysTextTransformer.vue?vue&type=script&lang=js"
import style0 from "./weekdaysTextTransformer.vue?vue&type=style&index=0&id=7fc22cb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc22cb7",
  null
  
)

export default component.exports